import React, { useEffect, useRef } from "react";
import {
  Box,
  Flex,
  FormControl,
  FormLabel,
  Input,
  Radio,
  RadioGroup,
  Stack,
  Text,
} from "@chakra-ui/react";
import BankDetails from "./BankDetails";
import AddressDetails from "./AddressDetails";
import PhoneNumberInput from "../../../atoms/PhoneNumberInput";
import EmailInput from "../../../atoms/EmailInput";
import PANInput from "../../../atoms/PANInput";
import GSTInput from "../../../atoms/GSTNumber";

// OwnerDetails component handles input fields for owner information
const OwnerDetails = ({
  activeStep,
  handleChange,
  initialValue: {
    ownertype,
    firstName,
    fatherName,
    contactNo,
    emailId,
    panNo,
    gstNo,
    paymentDetails,
    ...rest
  },
}) => {
  const myRef = useRef(null);
  // Function to handle form changes
  const handleFormChange = (e) => {
    handleChange(e, "owner");
  };

  // Function to handle radio button changes
  const handleRadioButton = (e, name) => {
    handleFormChange({ target: { name, value: e } });
  };

  useEffect(()=>{
    myRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
  },[])

  return (
    // Display only if activeStep is 1
    <Box ref={myRef} display={activeStep === 1 ? "block" : "none"}>
      {/* Title */}
      <Text color={"#9d9b9b"} mb={3}>
        Owner Details
      </Text>

      {/* Form fields */}
      <Flex justify="space-between" gap={3} mb={3}>
        {/* Type of owner */}
        <FormControl>
          <FormLabel color={"#191b1c"}>Type</FormLabel>
          <RadioGroup
            defaultValue={ownertype || "firm"}
            name="ownertype"
            onChange={(e) => handleRadioButton(e, "ownertype")}
          >
            <Stack direction="row">
              <Radio value="firm">Firm</Radio>
              <Radio value="individual">Individual</Radio>
            </Stack>
          </RadioGroup>
        </FormControl>

        {/* Name of Firm/Owner */}
        <FormControl isRequired>
          <FormLabel color={"#191b1c"}>Name of Firm/Owner</FormLabel>
          <Input
            name="firstName"
            value={firstName}
            type="text"
            onChange={handleFormChange}
          />
        </FormControl>

        {/* Father's Name */}
        <FormControl>
          <FormLabel color={"#191b1c"}>Father's Name</FormLabel>
          <Input
            name="fatherName"
            value={fatherName}
            type="text"
            onChange={handleFormChange}
          />
        </FormControl>
      </Flex>

      {/* Contact information */}
      <Flex justify="space-between" gap={3} mb={3}>
        {/* Contact No. */}
        <FormControl>
          <FormLabel color={"#191b1c"}>Contact No.</FormLabel>
          <PhoneNumberInput
            name="contactNo"
            value={contactNo}
            type="number"
            onChange={handleFormChange}
          />
        </FormControl>

        {/* Email ID */}
        <FormControl>
          <FormLabel color={"#191b1c"}>Email ID</FormLabel>
          <EmailInput
            name="emailId"
            value={emailId}
            type="text"
            onChange={handleFormChange}
          />
        </FormControl>

        {/* PAN No */}
        <FormControl>
          <FormLabel color={"#191b1c"}>PAN No</FormLabel>
          <PANInput
            name="panNo"
            value={panNo}
            type="text"
            onChange={handleFormChange}
          />
        </FormControl>
      </Flex>

      {/* GST No */}
      <Flex justify="space-between" gap={3} mb={3}>
        <FormControl>
          <FormLabel color={"#191b1c"}>GST No</FormLabel>
          <GSTInput
            name="gstNo"
            value={gstNo}
            type="text"
            onChange={handleFormChange}
          />
        </FormControl>
      </Flex>

      {/* Bank details */}
      <BankDetails
        onChange={handleFormChange}
        keyName="paymentDetails"
        paymentDetails={paymentDetails}
      />

      {/* Address details */}
      <AddressDetails onChange={handleFormChange} initialValue={rest} />
    </Box>
  );
};

export default OwnerDetails;
